<template>
  <validation-observer ref="simpleRules">
    <guides-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import GuidesItemForm from '@/views/Guides/ItemForm.vue'

export default {
  name: 'Add',
  components: { GuidesItemForm, ValidationObserver, SaveButton },
  data: () => ({ submitStatus: false }),
  computed: {
    itemData() {
      return this.$store.getters['guides/dataItem']
    },
    saveData() {
      return this.$store.getters['guides/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/guides/edit/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  created() {
    this.$store.commit('guides/RESET_DATA_ITEM')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('guides/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'), icon: 'XIcon', text: this.$t('common.requiredFields'), variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({ component: ToastificationContent, props: params }, { position: 'bottom-center' })
    },
  },
}
</script>
